import React, { useState } from 'react';

import { Typography, Divider } from '@telus-uds/components-web';

import FullyManaged from './fullyManaged/index';
import CopperInternet from './copperInternet';
import Wireline from './wirelineConsolidation';
import { TabButton } from './util';

export default function ProductCatalogueDashboard() {
  const [tabSelected, setTabSelected] = useState('FULLY_MANAGED');
  const tabComponents = {
    FULLY_MANAGED: <FullyManaged />,
    COPPER_INTERNET: <CopperInternet />,
    wireline: <Wireline />
  };
  return (
    <div className="container-90" style={{ padding: '2rem' }}>
      <Typography heading="h2" variant={{ size: 'h2' }} block>Product Catalogue Dashboard</Typography>
      <div
        style={{
          marginTop: '1rem',
          borderBottom: '1px solid #e4e4e4',
          padding: '0 0.5rem'
        }}
      >
        <ul
          style={{
            display: 'flex',
            gap: '2rem',
            listStyle: 'none',
            padding: 0,
            margin: 0
          }}
        >
          <TabButton
            label="Fully Managed"
            value="FULLY_MANAGED"
            tabSelected={tabSelected}
            setTabSelected={setTabSelected}
          />
          {/* <TabButton
            label="Copper Internet"
            value="COPPER_INTERNET"
            tabSelected={tabSelected}
            setTabSelected={setTabSelected}
          /> */}
          <TabButton
            label="Wireline 2.0"
            value="wireline"
            tabSelected={tabSelected}
            setTabSelected={setTabSelected}
          />
        </ul>
      </div>
      <Divider space={2} variant={{ inverse: true }}/>
      {tabComponents[tabSelected]}
    </div>
  );
}
